"use strict"

import ObservationPlotFactory from "../../../shared_components/graphing/plot_factories/ObservationPlotFactory"
import MultiRunPlotFactory from "../../../shared_components/graphing/plot_factories/MultiRunPlotFactory"
import ObsVsObsPlotFactory from "../../../shared_components/graphing/plot_factories/ObsVsObsPlotFactory"

export function makePlotFactoryForConfig(config) {
  if (!config) return null

  if (!config.special) {
    return new ObservationPlotFactory(config)
  } else if (config.special === "multi") {
    return new MultiRunPlotFactory(config)
  } else if (config.special === "obs-vs-obs") {
    return new ObsVsObsPlotFactory(config)
  } else {
    /*
      Unrecognized graph type:

      Could happen on a graph config shared from LanzaLake for example. LTPM doesn't
      do the same number of special graphs as LL e.g. graphing types related to 'Omics
      analysis.
    */
    return null
  }
}
